/* This file is autogenerated, see readme.md for instructions */
import ChatsSvgIcon from '@bloomreach/banana-theme/icons/chats.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ChatsIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ChatsSvgIcon />
    </Icon>
  );
});

ChatsIcon.displayName = 'ChatsIcon';

export default ChatsIcon;
